export function updateOneField(params) {
	let columnField = params.colDef.field;
	let newValue = params.value;
	let dataId = params.data.id;

	let changeUrl = detailLink.replace(9999999, dataId);

	var data = new FormData();
	data.append('_do', 'changeField')
	data.append('name', columnField)
	data.append('value', newValue)

	axios
		.post(changeUrl, data)
		.then(response => {
			if (response.status === 200 && response.data.result) {
				staticNotification.success('Data úspěšně změněna.');
				if (newValue.toString() != response.data.newValue.toString()) {
					updateGridRowData(response.data.model, false)
				}
			} else {
				staticNotification.error(response.data.errorMessage);
			}
		})

	if (columnField == 'default' && newValue == true) {
		gridSettings.api.forEachLeafNode(function (node, index) {
			if (node.data.id != params.data.id) {
				node.setDataValue('default', false);
			}
		});
	}
}

window.updateOneField = updateOneField

export function updateGridRowData(data, showMessage = true) {
	if (typeof window.gridSettings.api === 'undefined') {
		return;
	}

	if (window.gridSettings.treeData) {
		if (window.gridSettings.rowModelType === 'serverSide') {
			window.fetchNewTreeData(window.gridDataUrl);
		} else {
			window.loadNewDataFromUrl(window.gridDataUrl);
		}
		return;
	}

	let rowNode = gridSettings.api.getRowNode(data.id);
	if (typeof rowNode !== "undefined") {
		gridSettings.api.updateRowData({update: [data]});
		gridSettings.api.redrawRows({rowNodes: [rowNode]});
	} else {
		gridSettings.api.updateRowData({add: [data]});
	}

	let node = gridSettings.api.getRowNode(data.id);
	node.setSelected(true, true);
	gridSettings.api.setFocusedCell(node.rowIndex, 'id');

	// scrollToFirstSelectedRow();
}
